'use client';

import { ToastContainer, ToastContainerProps } from 'react-toastify';

const CustomToastContainer = (props: ToastContainerProps & TClassNameProps) => <ToastContainer {...props} />;

export default CustomToastContainer;
